import ContainerStyles from "./Container.module.scss";

const Container = (props: any): any => {
  return (
    <div className={`${ContainerStyles.containerCard} ${props.className}`}>
      {props.children}
    </div>
  );
};
export default Container;
